export enum ResponseHeaders {
  NEXT_PAGE_TOKEN_HEADER = 'x-meta-next-page-token',
  PREV_PAGE_TOKEN_HEADER = 'x-meta-prev-page-token',
  LIST_ITEMS_COUNT_HEADER = 'x-meta-count',
}
